/*
 * @Author: EdwardYoung
 * @Date: 2017-07-26 19:11:50
 * @Last Modified by: EdwardYoung
 * @Last Modified time: 2017-08-22 17:33:50
 * 根据url判断player身份
 * 含play_id则是用户在查看他人分享的活动，无则是查看自己
 */

function getPlayer () {
  let searchUrlArray = window.location.search.slice(1).split('&')
  // let searchUrlArray = `?yhsd-play-mode=kanjia&kj-campaign-id=5979aa28bf47560500000007&kj-play-id=0c3c0e9b4071f6a9662e413257179e09`.slice(1).split('&')
  // let searchUrlArray = `?yhsd-play-mode=kanjia&kj-campaign-id=5979aa28bf47560500000007`.slice(1).split('&')
  let player = {
    campaignId: '',
    playId: ''
  }
  for (const item of searchUrlArray) {
    const numActivityId = item.indexOf('kj-campaign-id')
    const numPlayId = item.indexOf('kj-play-id')
    if (numActivityId !== -1) {
      const array = item.split('=')
      player.campaignId = array[1]
    }
    if (numPlayId !== -1) {
      const array = item.split('=')
      player.playId = array[1]
    }
  }
  return player
}

export {getPlayer}



// WEBPACK FOOTER //
// ./src/common/util/getPlayer.js